<template>
  <div class="bg-sub2">
    <div class="header-page container">
      <div class="col-all"  v-if="watchlater.length">
        <div class="col-left">
          <div class="" >
            <figure class="sixteen-nine-fav">
              <!--img src="../../src/assets/img/default.jpg" /-->
              <img :src="watchlaterLg.thumb" >
              <span class="poster-text" @click="PlayWatchLaterLg()">
                <p> <fa icon="play" class="" /> เล่นวีดีโอ</p>
              </span>
            </figure>
          </div>
          <div class="count-fav">
            <h4><i class="fa fa-fighter-jet"></i> ดูย้อนหลัง</h4>
            <p>ทั้งหมด {{watchlater.length}} วีดีโอ</p>
          </div>
        </div>


        <div class="col-right">
          <div class="" v-for="video in watchlater">
            <div class="delete-watchlater" @click="DeleteWatchLater(video)">
              <fa icon="trash" class="icon-watchlater"/>
            </div>
            <div class="box-favorite" @click="PlayWatchLaterContent(video)">
              <div class="video-favorite">
                <figure class="sixteen-nine-img float-left thumb-favorite">
                  <p class="duration">{{video.duration}}</p>
                  <img :src="video.thumb" >
                  <div class="btn-overlay-cate">
                    <fa icon="play" class="icon-play"/>
                  </div>
                </figure>
              </div>
              <div class="detail-favorite">
                <h5 class="title-favorite">{{video.name}}</h5>
                <p class="channal-favorite">{{video.desc}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container notfound text-center" v-if="!watchlater.length">
        <img src="../../src/assets/img/finallogo.png" alt="" class="img-category">
        <h3 class="text-category">ไม่มีวีดีโอในหมวดหมู่นี้</h3>
      </div>


    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  mdbRow,
  mdbCol,
  Btn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  Fa
} from 'mdbvue';
export default {
  name: 'WatchlaterPage',
  components: {
    mdbRow,
    mdbCol,
    Btn,
    mdbCard,
    mdbCardBody,
    Fa,
    mdbCardHeader
  },
  data() {
    return {
      watchlater: [],
      watchlaterLg: null
    };
  },
  mounted() {
    this.WatchLaterList();
    this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    PlayWatchLaterLg() {
      document.location.assign('/#/vod/' + this.watchlaterLg.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    PlayWatchLaterContent(data) {
      document.location.assign('/#/vod/' + data.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    WatchLaterList() {
      let APIgetWatchLaterList = Host + '/api/v1/watchlater';
      axios.post(APIgetWatchLaterList , {
        email: localStorage.emailfront
      }).then(response => {
        this.watchlater = response.data.result;
        this.watchlaterLg = response.data.result[0];
      });
    },
    DeleteWatchLater(data) {
      let APIgetDeleteWatchLater = Host + '/api/v1/watchlater/delete';
      axios.post(APIgetDeleteWatchLater , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.WatchLaterList();
      });
    }
  }
};
</script>

<style >

.xxx {
  display: flex;
}

</style>
